import { translate } from "@/utils/format";
import type { SponsoredFailReason, SponsoredStatus } from "@/services/sponsored";

export function reasonMessage(reason: SponsoredFailReason): string {
    switch (reason) {
        case "user_not_found":
            return translate(
                "PARTNER_SPONSORED_ERR_NOT_FOUND",
                "No hay ningún usuario de Caloo con ese email. Pídele que se registre y vuelve a intentarlo.",
            );
        case "already_premium":
            return translate(
                "PARTNER_SPONSORED_ERR_PREMIUM",
                "Esta persona ya tiene una suscripción activa pagada por ella. No hace falta pagarle otra.",
            );
        case "already_sponsored":
            return translate(
                "PARTNER_SPONSORED_ERR_SPONSORED",
                "Ya estás pagando la suscripción de esta persona.",
            );
        case "linked_to_other_partner":
            return translate(
                "PARTNER_SPONSORED_ERR_OTHER_PARTNER",
                "Esta persona está vinculada a otro centro, así que no puedes pagarle la suscripción.",
            );
        case "invalid_email":
            return translate(
                "PP_ERROR_INVALID_EMAIL",
                "Introduce un email válido.",
            );
        case "no_payment_method":
            return translate(
                "PARTNER_SPONSORED_ERR_NO_PM",
                "Primero guarda un método de pago.",
            );
        case "payment_failed":
            return translate(
                "PARTNER_SPONSORED_ERR_PAYMENT",
                "El pago no se ha completado. Revisa tu método de pago e inténtalo de nuevo.",
            );
        case "requires_action":
            return translate(
                "PARTNER_SPONSORED_ERR_ACTION",
                "Tu banco necesita confirmar este pago.",
            );
        default:
            return translate(
                "PP_ERROR_GENERIC",
                "Ha ocurrido un error. Inténtalo de nuevo.",
            );
    }
}

export function statusLabel(status: SponsoredStatus): string {
    switch (status) {
        case "active":
            return translate("PARTNER_SPONSORED_ST_ACTIVE", "Activa");
        case "canceling":
            return translate("PARTNER_SPONSORED_ST_CANCELING", "Se cancela");
        case "past_due":
            return translate("PARTNER_SPONSORED_ST_PAST_DUE", "Pago pendiente");
        case "incomplete":
            return translate("PARTNER_SPONSORED_ST_INCOMPLETE", "Incompleta");
        default:
            return translate("PARTNER_SPONSORED_ST_CANCELED", "Cancelada");
    }
}
